/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusSuccessDto } from '../../models/lexplus-success-dto';
import { LexplusUpdateNotizDto } from '../../models/lexplus-update-notiz-dto';

export interface IndividuelleAnforderungDetailControllerUpdateIndividuelleAnforderungNotizV1$Params {
  individuelleAnforderungID: string;
  verlaufID: string;
      body: LexplusUpdateNotizDto
}

export function individuelleAnforderungDetailControllerUpdateIndividuelleAnforderungNotizV1(http: HttpClient, rootUrl: string, params: IndividuelleAnforderungDetailControllerUpdateIndividuelleAnforderungNotizV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusSuccessDto>> {
  const rb = new RequestBuilder(rootUrl, individuelleAnforderungDetailControllerUpdateIndividuelleAnforderungNotizV1.PATH, 'patch');
  if (params) {
    rb.path('individuelleAnforderungID', params.individuelleAnforderungID, {});
    rb.path('verlaufID', params.verlaufID, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusSuccessDto>;
    })
  );
}

individuelleAnforderungDetailControllerUpdateIndividuelleAnforderungNotizV1.PATH = '/v1/compliance/firmeninterne-anforderungen/{individuelleAnforderungID}/notizen/{verlaufID}';
